import { render, staticRenderFns } from "./LoginRegisterDialog.vue?vue&type=template&id=0db165fa&"
import script from "./LoginRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports